import { SegmentedRadioGroupField } from '@hex/calculators-shared/components';
import { useSapphireMedia } from '@hex/calculators-shared/hooks';
import { PropertyType } from '@hex/calculators-shared/types/affordability';
import { Icon, Label, SegmentedRadio, tokens } from '@sapphire-react/core';
import { Home, Building, Campsite } from '@sapphire/icons/react';
import { type Control, type RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  control: Control<any>;
  rules: RegisterOptions;
};

export function PropertyTypeField({ control, rules }: Props) {
  const { t } = useTranslation();
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const inputSize = isExtraSmall || isSmall ? 'md' : 'lg';

  return (
    <div>
      <Label aria-label={t('personalInformation.inputs.property.label')} htmlFor={'propertyType'}>
        {t('personalInformation.inputs.property.label')}
      </Label>
      <SegmentedRadioGroupField
        control={control}
        rules={rules}
        aria-label={t('personalInformation.inputs.property.placeholder')}
        name={'propertyType'}
        width={'100%'}
        marginTop={tokens.size.spacing2xs}
        data-test-id={'propertyType'}
      >
        <SegmentedRadio
          value={PropertyType.Villa}
          data-cblabel={t('personalInformation.inputs.property.options.villa')}
          aria-label={t('personalInformation.inputs.property.options.villa')}
        >
          <Icon size={inputSize} marginRight={tokens.size.spacingXs}>
            <Home />
          </Icon>
          {t('personalInformation.inputs.property.options.villa')}
        </SegmentedRadio>
        <SegmentedRadio
          value={PropertyType.Apartment}
          data-cblabel={t('personalInformation.inputs.property.options.apartment')}
          aria-label={t('personalInformation.inputs.property.options.apartment')}
        >
          <Icon size={inputSize} marginRight={tokens.size.spacingXs}>
            <Building />
          </Icon>
          {t('personalInformation.inputs.property.options.apartment')}
        </SegmentedRadio>
        <SegmentedRadio
          value={PropertyType.HolidayHouse}
          data-cblabel={t('personalInformation.inputs.property.options.recreational')}
          aria-label={t('personalInformation.inputs.property.options.recreational')}
        >
          <Icon size={inputSize} marginRight={tokens.size.spacingXs}>
            <Campsite />
          </Icon>
          {t('personalInformation.inputs.property.options.recreational')}
        </SegmentedRadio>
      </SegmentedRadioGroupField>
    </div>
  );
}
